import { BaseError } from '@dynamic-labs-sdk/client';

export type PhantomRedirectRejectedErrorParams = {
  errorCode: string;
  errorMessage?: string;
};

export class PhantomRedirectRejectedError extends BaseError {
  constructor({ errorCode, errorMessage }: PhantomRedirectRejectedErrorParams) {
    super({
      cause: null,
      code: 'phantom_redirect_rejected_error',
      details: errorMessage,
      docsUrl: null,
      metaMessages: [`Error Code: ${errorCode}`],
      name: 'PhantomRedirectRejectedError',
      shortMessage: 'User rejected the request in Phantom wallet.',
    });
  }
}
